define('plugin/package/model/PackageInstanceModel',['require','lib/model/BaseModel'],function (require) {

    var BaseModel = require('lib/model/BaseModel');

    /**
     * Package instance model
     *
     * @class PackageInstanceModel
     */
    return BaseModel.extend({

        defaults: {
            id: null,
            package: null
        }

    });

});
